import { Navigate, useParams } from "react-router";

export function RedirectTranscriptionPage() {
  const { transcriptId } = useParams();

  return (
    <Navigate
      to={
        transcriptId !== undefined
          ? `/transcriptions/${transcriptId}`
          : "/transcriptions"
      }
      replace
    />
  );
}
